import { Route, Switch, useRouteMatch } from 'react-router-dom';
import React from 'react';
import { TimeSlotsView } from './timeslots.view';

/**
 * Routeur pour la gestion des créneaux horaires d'activités supervisées
 * 
 * Ce routeur gère la navigation pour :
 * - Vue principale des créneaux horaires (/timeslots)
 * 
 * Logique métier :
 * - Route unique vers la vue des créneaux horaires
 * - Gestion des activités supervisées uniquement
 * - Interface de gestion des créneaux avec filtrage
 * 
 * @returns Composant React du routeur des créneaux horaires
 */
export const TimeSlotsRouter = () => {
  let { path } = useRouteMatch();

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <TimeSlotsView />
        </Route>
      </Switch>
    </div>
  );
};
